var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
        persistent: "",
        "max-width": "600px",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "SecondaryBtn",
                _vm._g(
                  {
                    attrs: { light: "", color: "info", icon: "system_update" },
                  },
                  on
                ),
                [_vm._v("\n      Install Services\n    ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("ExecutionResultsDialog", { ref: "executionResultsDialog" }),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { dark: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [_vm._v("Install Services")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.tenants,
                  multiple: "",
                  label: "Tenants",
                  "item-text": "RoleName",
                  "item-value": "Id",
                },
                model: {
                  value: _vm.formObject.tenantIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.formObject, "tenantIds", $$v)
                  },
                  expression: "formObject.tenantIds",
                },
              }),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  items: _vm.services,
                  multiple: "",
                  label: "Services",
                  "item-text": "DisplayName",
                  "item-value": "Id",
                },
                model: {
                  value: _vm.formObject.serviceIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.formObject, "serviceIds", $$v)
                  },
                  expression: "formObject.serviceIds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "PrimaryBtn",
                {
                  attrs: {
                    color: "success",
                    icon: "system_update",
                    disabled: false,
                    loading: _vm.isSaving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v("\n        Install\n      ")]
              ),
              _vm._v(" "),
              _c("CloseBtn", {
                attrs: { primary: "", disabled: _vm.isBlocked },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }